import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51099f1b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-1" }

import ResponsiveImage from '../responsive-image.vue';
import Participate from '../participate/index.vue';
import { IProgram } from '@/types/program';

interface Props {
  program: IProgram;
}interface Emits {
  (event: 'request-collection') :void;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    program: null
  },
  emits: ["request-collection"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'request-collection') :void;
}), expose: any, slots: any, attrs: any }) {

;




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ResponsiveImage, {
      image: require('./bg.jpg'),
      "mobile-image": require('./bg-m.jpg'),
      "image-webp": require('./bg.webp'),
      "mobile-image-webp": require('./bg-m.webp'),
      "image-h": 1418,
      "image-w": 3840,
      "mobile-image-h": 1401,
      "mobile-image-w": 1170
    }, null, 8, ["image", "mobile-image", "image-webp", "mobile-image-webp"]),
    _createVNode(Participate, {
      program: __props.program,
      class: "btn-participate"
    }, null, 8, ["program"]),
    _createElementVNode("div", {
      class: "btn-apply",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('request-collection')))
    })
  ]))
}
}

})